import React from 'react';
import LeaderboardScreen from './LeaderboardScreen';

const LeaderBoardTab: React.FC = () => {
  return <LeaderboardScreen/>
};

export default React.memo(LeaderBoardTab);
